import React, { Component } from "react";
import CssClasses from "./AdditionalBets.css";
import { connect } from "react-redux";
import Auxx from "../../HOCs/AUXX/Auxx";
import * as StoreActions from "../../ReduxStore/Actions/ActionIndex";
import { GetConvertedOdds } from "../../HOCs/Helpers/OddConverter";
import { ConvertEmmettSportIDToBetRadarID } from "../../HOCs/Helpers/SportConverter";

import SiteIcons from "../../assets/fonts/site_icons/style.css";
import imgClose from "../../assets/images/icons/icon_close_simple.png";

import beepMedium from "../../assets/sounds/beep_medium.mp3";

import iconInfoInactive from "../../assets/images/icons/icon_info_inactive_light.png";
import iconInfoActive from "../../assets/images/icons/icon_info_active.png";

import { GetTicketPairs } from "../../Communication/PrematchInfoServicesHandler";

import { ConvertLanguageCodeToJezikID } from "../../HOCs/Helpers/LanguageConverter";

class AdditionalBets extends Component {
  //console.log("AdditionalBets MATCHES: ", props.liveMatchesList);

  state = {
    currentShownInfoBoxID: -1
  };

  render() {
    if (this.props.shouldQuickCloseExtraBets) {
      return null;
    }

    //podesi boje
    let headerRowClass = CssClasses.headerRowColorDefault;
    let mainRowClass = CssClasses.mainRowColorDefault;
    let separatorRowClass = CssClasses.separatorDefault;

    let sportID = -1;

    if (this.props.isForPrematch) {
      sportID = ConvertEmmettSportIDToBetRadarID(
        this.props.currentPrematchSportID
      );
    } else {
      sportID = this.props.currentLiveSportID;
    }

    //i dodaj boju ovisno o sportu
    switch (sportID) {
      case 1: //Soccer
        headerRowClass = CssClasses.headerRowColorSoccer;
        mainRowClass = CssClasses.mainRowColorSoccer;
        separatorRowClass = CssClasses.separatorSoccer;
        break;
      case 2: //basketball
        headerRowClass = CssClasses.headerRowColorBasketball;
        mainRowClass = CssClasses.mainRowColorBasketball;
        separatorRowClass = CssClasses.separatorBasketball;
        break;
      case 3: //baseball
        headerRowClass = CssClasses.headerRowColorBaseball;
        mainRowClass = CssClasses.mainRowColorBaseball;
        separatorRowClass = CssClasses.separatorBaseball;
        break;
      case 4: //hockey
        headerRowClass = CssClasses.headerRowColorHockey;
        mainRowClass = CssClasses.mainRowColorHockey;
        separatorRowClass = CssClasses.separatorHockey;
        break;
      case 5: //tennis
        headerRowClass = CssClasses.headerRowColorTennis;
        mainRowClass = CssClasses.mainRowColorTennis;
        separatorRowClass = CssClasses.separatorTennis;
        break;
      case 6: //handball
        headerRowClass = CssClasses.headerRowColorHandball;
        mainRowClass = CssClasses.mainRowColorHandball;
        separatorRowClass = CssClasses.separatorHandball;
        break;
      case 12: //rugby
        headerRowClass = CssClasses.headerRowColorRugby;
        mainRowClass = CssClasses.mainRowColorRugby;
        separatorRowClass = CssClasses.separatorRugby;
        break;
      case 16: //Football
        headerRowClass = CssClasses.headerRowColorFootball;
        mainRowClass = CssClasses.mainRowColorFootball;
        separatorRowClass = CssClasses.separatorFootball;
        break;
      case 19: //Snooker
        headerRowClass = CssClasses.headerRowColorSnooker;
        mainRowClass = CssClasses.mainRowColorSnooker;
        separatorRowClass = CssClasses.separatorSnooker;
        break;
      case 20: //TableTennis
        headerRowClass = CssClasses.headerRowColorTableTennis;
        mainRowClass = CssClasses.mainRowColorTableTennis;
        separatorRowClass = CssClasses.separatorTableTennis;
        break;
      case 23: //volleyball
        headerRowClass = CssClasses.headerRowColorVolleyball;
        mainRowClass = CssClasses.mainRowColorVolleyball;
        separatorRowClass = CssClasses.separatorVolleyball;
        break;
      case 29: //futsal
        headerRowClass = CssClasses.headerRowColorFutsal;
        mainRowClass = CssClasses.mainRowColorFutsal;
        separatorRowClass = CssClasses.separatorFutsal;
        break;
      case 31: //Badminton
        headerRowClass = CssClasses.heaaderRowColorBadminton;
        mainRowClass = CssClasses.mainRowColorBadminton;
        separatorRowClass = CssClasses.separatorBadminton;
        break;
      default:
        break;
    }

    if (this.props.isForPrematch) {
      //resetiraj boju na sivu
      mainRowClass = CssClasses.mainRowColorDefault;
      separatorRowClass = CssClasses.separatorDefault;
    }

    //stvori klase za extrabets
    let extraBetsClasses = [CssClasses.extraBetsContainer];

    if (this.props.liveExtraBetsID > 0 || this.props.prematchExtraBetsID > 0) {
      //dodaj show
      extraBetsClasses.push(CssClasses.showExtraBetsContainer);
    } else {
      //Dodaj hide
      if (this.props.shouldQuickCloseExtraBets) {
        extraBetsClasses.push(CssClasses.quickHideExtraBetsContainer);
      } else {
        extraBetsClasses.push(CssClasses.hideExtraBetsContainer);
      }
    }

    if (this.props.isForPrematch) {
      extraBetsClasses.push(CssClasses.forPrematch);
    }

    //push boju
    extraBetsClasses.push(mainRowClass);

    var match = this.props.match;
    var betList = this.props.allBets ? [...this.props.allBets] : []; //kopija jer cemo mijenjati
    var betTexts = this.props.allBetsText;
    var betInfos = match ? match.betInfo : [];

    // console.log("-match is ", match);
    // console.log("-bet list is ", betList);
    // console.log("-bet text is ", betTexts);
    // console.log("-bet infos is ", betInfos);

    if (!match || !betList) {
      return <div className={extraBetsClasses.join(" ")}>&nbsp;</div>;
    }

    var displayBetList = [];

    var bet;
    var tmpIdx;
    var keyCtr = 0;

    //napravi svoj novi bet list
    for (let i = 0; i < betInfos.length; i++) {
      //vidi ako ima marginu
      var bi = betInfos[i];

      //console.log("CURRENT BETINFO IS ", bi);

      if (bi.margin && bi.margin !== "") {
        //provjeri da nije vec dodano
        tmpIdx = displayBetList.findIndex(
          // eslint-disable-next-line no-loop-func
          x => x.svoID === bi.sportVrstaOkladaID && x.margin === bi.margin
        );
        if (tmpIdx !== -1) {
          //dodano vec, continue
          //console.log("---> DODANA!");

          continue;
        }

        keyCtr++;

        //ide u novi
        //dohvati bet
        // eslint-disable-next-line no-loop-func
        bet = { ...betList.find(x => x.svoID === bi.sportVrstaOkladaID) }; //kopiju zbog bugova

        //console.log("TEMP BET IS ", bet);

        //provjera ako ima propertija, znaci da nije prazan objekt
        if (Object.keys(bet).length !== 0) {
          bet.margin = bi.margin;
          bet.renderKey = keyCtr;
          displayBetList.push(bet);
        } else {
          console.log("!!!!!!!!!!!!!!! PRAZAN BET !!!!!!!!!!!");
        }
      }
    }

    //dodaj jos iz betlist sve koji nema
    for (let i = 0; i < betList.length; i++) {
      bet = betList[i];

      //nadji ako je vec u display listi
      tmpIdx = displayBetList.findIndex(x => x.svoID === bet.svoID);
      if (tmpIdx === -1) {
        //dodaj
        keyCtr++;
        bet.renderKey = keyCtr;
        displayBetList.push(bet);
      }
    }

    //ako nije za prematch, ostavi kako je bilo!
    if (!this.props.isForPrematch) {
      displayBetList = betList;

      //ali nakaci renderkey
      for (let i = 0; i < displayBetList.length; i++) {
        bet = displayBetList[i];
        keyCtr++;
        bet.renderKey = keyCtr;
      }
    }

    for (let i = 0; i < displayBetList.length; i++) {
      const bet = displayBetList[i];

      //nadji txt
      let txt = betTexts.find(x => x.svoID === bet.svoID);
      // console.log("TEXT ", txt);
      // console.log("BET ", bet);
      //bet.Naziv = txt.Naziv.replace("1$", bet.PosebnaVrijednost);
      bet.Naziv = txt.Naziv;

      if (bet.margin) {
        bet.Naziv = bet.Naziv + " [" + bet.margin + "]";

        //ako nema posebnu vrijednost, potavi ju
        if (!bet.PosebnaVrijednost) {
          bet.PosebnaVrijednost = parseFloat(bet.margin);
        }
      }

      bet.Redoslijed = txt.Redoslijed;

      if (!bet.Opis) {
        bet.Opis = txt.DugiNaziv;

        bet.Opis = bet.Opis.replace("d!", match.homeTeam);
        bet.Opis = bet.Opis.replace("g!", match.guestTeam);
      }

      //console.log("TXT ", txt);

      //obradi naziv za extra bets
      if (bet.Naziv.indexOf("$") > -1) {
        var tmpString = "";
        var indReplace = 1;

        if (txt.predznakNaslov === 1) {
          var posVrj = bet.PosebnaVrijednost;
          if (parseFloat(posVrj) > 0) {
            posVrj = "+" + posVrj;
          }
          bet.Naziv = bet.Naziv.replace("1$", posVrj);
          bet.Opis = bet.Opis.replace("1$", posVrj);
        } else if (
          bet.PosebnaVrijednost.indexOf("-") > 0 &&
          bet.PosebnaVrijednost.indexOf("/-") === -1
        ) {
          tmpString = bet.PosebnaVrijednost.replace("and", "-").split("-");
          indReplace = 1;

          for (let i = 0; i < tmpString.length; i++) {
            const char = tmpString[i];
            bet.Naziv = bet.Naziv.replace(indReplace.toString() + "$", char);
            bet.Opis = bet.Opis.replace(indReplace.toString() + "$", char);
            indReplace++;
          }
        } else {
          tmpString = bet.PosebnaVrijednost.split("/");
          indReplace = 1;
          for (let i = 0; i < tmpString.length; i++) {
            const char = tmpString[i];
            bet.Naziv = bet.Naziv.replace(indReplace.toString() + "$", char);
            bet.Opis = bet.Opis.replace(indReplace.toString() + "$", char);
            indReplace++;
          }
        }
      }
    }

    //sortni
    displayBetList.sort((a, b) => {
      return a.Redoslijed - b.Redoslijed === 0
        ? a.PosebnaVrijednost - b.PosebnaVrijednost
        : a.Redoslijed - b.Redoslijed;
    });

    //console.log(betList);
    // console.log("ALLBETSW ", props.props.a);
    // console.log("EXTRABETSID ", props.liveExtraBetsID);
    //console.log(betListTexts);

    console.log("DISPLAY BET LIST ", displayBetList);

    return (
      <div className={extraBetsClasses.join(" ")}>
        <audio
          ref={sound => {
            this.beepMedium = sound;
          }}
        >
          <source src={beepMedium} type="audio/mpeg" />
        </audio>

        {/* hack da forsira update
      <span style={{ display: "none" }}>{props.updateStampOData}</span> */}
        <div className={[CssClasses.extraBetHeader, headerRowClass].join(" ")}>
          {this.getHeaderMarkup(match)}
        </div>

        <div
          className={[
            CssClasses.betsContainer,
            this.props.isForPrematch ? CssClasses.prematchBetsContainer : ""
          ].join(" ")}
        >
          {displayBetList.map(bet => {
            //console.log("BET: ", bet.Naziv);
            //console.log("---> ", bet);

            //nadji bettext za opis

            return (
              <div
                className={[CssClasses.betGroupRow, separatorRowClass].join(
                  " "
                )}
                key={bet.renderKey}
              >
                {this.getExclusiveIcon(bet.Exkluziv1, bet.Exkluziv2)}
                <div className={CssClasses.betTitle}>
                  {bet.Naziv}
                  <img
                    src={
                      this.state.currentShownInfoBoxID === bet.renderKey
                        ? iconInfoActive
                        : iconInfoInactive
                    }
                    alt=""
                    className={CssClasses.iconInfo}
                    onClick={() => {
                      this.btnBetInfo_Click(bet.renderKey);
                    }}
                  />
                </div>

                {this.getBetInfo(bet.IDOklada, bet.Opis, bet.renderKey)}

                {this.getButtons(match, bet.IDOklada, bet.margin)}
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  btnBetInfo_Click = id => {
    console.log("id " + id);

    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    if (this.state.currentShownInfoBoxID === id) {
      //gasi
      this.setState({ currentShownInfoBoxID: -1 });
    } else {
      this.setState({ currentShownInfoBoxID: id });
    }
  };

  closeExtraBets = () => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    this.props.onSetLiveExtraBetsID(-1);
    this.props.onSetPrematchExtraBetsID(-1);

    //nakon timeouta upali
    setTimeout(() => {
      this.props.setCanShowExtraLiveBets(true);
      this.props.setCanShowExtraPrematchBets(true);
      console.log("PALIM...");
    }, 1000);
  };

  getBetInfo = (idOklada, description, renderKey) => {
    var classes = [CssClasses.betDescriptionBox];

    if (this.state.currentShownInfoBoxID === renderKey) {
      classes.push(CssClasses.descriptionShown);
    } else {
      classes.push(CssClasses.descriptionHidden);
    }

    return <div className={[classes.join(" ")]}>{description}</div>;
  };

  getExclusiveIcon = (exkl1, exkl2) => {
    var baseClass = CssClasses.baseBoxExclusive;
    var customClass = "";

    if (!exkl1 || exkl1 === 0) {
      //nema indikatora
      return null;
    }

    //pripremi klasu
    switch (exkl1) {
      case 1:
        customClass = CssClasses.boxExclusive11;
        break;
      case 2:
        customClass = CssClasses.boxExclusive12;
        break;
      case 3:
        customClass = CssClasses.boxExclusive13;
        break;
      case 4:
        customClass = CssClasses.boxExclusive14;
        break;
      case 5:
        customClass = CssClasses.boxExclusive15;
        break;
      default:
        break;
    }

    switch (exkl2) {
      case 1:
        customClass = CssClasses.boxExclusive21;
        break;
      case 2:
        customClass = CssClasses.boxExclusive22;
        break;
      case 3:
        customClass = CssClasses.boxExclusive23;
        break;
      case 4:
        customClass = CssClasses.boxExclusive24;
        break;
      case 5:
        customClass = CssClasses.boxExclusive25;
        break;
      default:
        break;
    }

    //i vrati div
    return <div className={[baseClass, customClass].join(" ")}>&nbsp;</div>;
  };

  getHeaderMarkup = match => {
    //console.log(match);

    if (match.sportID === 1) {
      //fudbal
      return (
        <Auxx>
          <span className={CssClasses.leagueName}>{match.tournamentName}</span>
          <img
            src={imgClose}
            className={CssClasses.btnClose}
            alt=""
            onClick={() => {
              this.closeExtraBets();
              return;
            }}
          />
          <hr className={CssClasses.headerSeparator} />

          {/* prvi redak */}

          <div className={[CssClasses.colWide, CssClasses.lblTime].join(" ")}>
            <div
              className={[CssClasses.activeIndicator, CssClasses.flickers].join(
                " "
              )}
            >
              &nbsp;
            </div>

            {match.currentTime}
          </div>
          <div className={CssClasses.colSmall}>
            <span
              className={[
                SiteIcons.site_icon_football_ball,
                CssClasses.legendIcon
              ].join(" ")}
            />
          </div>
          <div className={CssClasses.colSmall}>45'</div>
          <div className={CssClasses.colSmall}>
            <span
              className={[
                SiteIcons.site_icon_corner_flag,
                CssClasses.legendIcon
              ].join(" ")}
            />
          </div>
          <div className={CssClasses.colSmall}>
            <span
              className={[
                SiteIcons.site_icon_card_yellow_single,
                CssClasses.legendIcon
              ].join(" ")}
            />
          </div>
          <div className={CssClasses.colSmall}>
            <span
              className={[
                SiteIcons.site_icon_card_red_single,
                CssClasses.legendIcon
              ].join(" ")}
            />
          </div>
          <div className={CssClasses.colSmall}>
            <span
              className={[
                SiteIcons.site_icon_card_yellow_single,
                CssClasses.legendIcon
              ].join(" ")}
            />
            <span
              className={[
                SiteIcons.site_icon_card_red_single,
                CssClasses.legendIcon,
                CssClasses.secondCard
              ].join(" ")}
            />
          </div>

          {/* <div className={[CssClasses.colExtra, CssClasses.lastItem].join(" ")}>
          <span
            className={[
              SiteIcons.site_icon_statistics,
              CssClasses.legendIcon
            ].join(" ")}
          />
        </div>
        <div className={CssClasses.colExtra}>
          <span
            className={[SiteIcons.site_icon_eye, CssClasses.legendIcon].join(
              " "
            )}
          />
        </div> */}

          <div className={CssClasses.spacer} />

          {/* drugi redak */}

          <div className={[CssClasses.colWide, CssClasses.lblTeam].join(" ")}>
            {match.homeTeam}
          </div>
          <div className={[CssClasses.colSmall, CssClasses.lblScore].join(" ")}>
            {match.scoreHome}
          </div>
          <div
            className={[CssClasses.colSmall, CssClasses.lblGeneric].join(" ")}
          >
            {match.scoreHalfTimeHome} {/* 0 poluvreme */}
          </div>
          <div
            className={[CssClasses.colSmall, CssClasses.lblGeneric].join(" ")}
          >
            {match.cornersHome} {/* korneri */}
          </div>
          <div
            className={[CssClasses.colSmall, CssClasses.lblGeneric].join(" ")}
          >
            {match.yellowCardsHome}
          </div>
          <div
            className={[CssClasses.colSmall, CssClasses.lblGeneric].join(" ")}
          >
            {match.redCardsHome}
          </div>
          <div
            className={[CssClasses.colSmall, CssClasses.lblGeneric].join(" ")}
          >
            {match.yellowToRedCardsHome}
          </div>

          <div className={CssClasses.clearFix} />

          {/* treci redak */}

          <div className={[CssClasses.colWide, CssClasses.lblTeam].join(" ")}>
            {match.guestTeam}
          </div>
          <div className={[CssClasses.colSmall, CssClasses.lblScore].join(" ")}>
            {match.scoreGuest}
          </div>
          <div
            className={[CssClasses.colSmall, CssClasses.lblGeneric].join(" ")}
          >
            {match.scoreHalfTimeGuest} {/* 0 poluvreme */}
          </div>
          <div
            className={[CssClasses.colSmall, CssClasses.lblGeneric].join(" ")}
          >
            {match.cornersGuest} {/* korneri */}
          </div>
          <div
            className={[CssClasses.colSmall, CssClasses.lblGeneric].join(" ")}
          >
            {match.yellowCardsGuest}
          </div>
          <div
            className={[CssClasses.colSmall, CssClasses.lblGeneric].join(" ")}
          >
            {match.redCardsGuest}
          </div>
          <div
            className={[CssClasses.colSmall, CssClasses.lblGeneric].join(" ")}
          >
            {match.yellowToRedCardsGuest}
          </div>

          <div className={CssClasses.spacer} />
        </Auxx>
      );
    } else {
      //sort set info

      return (
        <Auxx>
          <span className={CssClasses.leagueName}>{match.tournamentName}</span>
          <img
            src={imgClose}
            className={CssClasses.btnClose}
            alt=""
            onClick={() => {
              this.closeExtraBets();
              return;
            }}
          />
          <hr className={CssClasses.headerSeparator} />

          {/* prvi redak */}

          {this.props.isForPrematch ? null : (
            <Auxx>
              <div
                className={[CssClasses.colWide, CssClasses.lblTime].join(" ")}
              >
                <div
                  className={[
                    CssClasses.activeIndicator,
                    CssClasses.flickers
                  ].join(" ")}
                >
                  &nbsp;
                </div>

                {match.currentTime}
              </div>
              <div className={CssClasses.spacer} />
            </Auxx>
          )}

          {/* drugi redak */}
          <div className={CssClasses.matchInfoContainer}>
            <div className={CssClasses.teamsGroup}>
              <div className={CssClasses.teamHome}>{match.homeTeam}</div>
              <div className={CssClasses.teamGuest}>{match.guestTeam}</div>
            </div>

            {/* odobrio jakov jer nema mejsta 2.12. */}

            {/* {match.scoreTotalHome !== "" ? (
              <div className={CssClasses.totalScoreBox}>
                <div className={CssClasses.totalScoreHome}>
                  {match.scoreTotalHome}
                </div>
                <div className={CssClasses.totalScoreGuest}>
                  {match.scoreTotalGuest}
                </div>
              </div>
            ) : null}

            {match.sportID === 5 ? ( //tenis
              <Auxx>
                <div className={CssClasses.currentServeBox}>
                  <div className={CssClasses.currentServeHome}>
                    {match.homeHasServe ? (
                      <span
                        className={[
                          SiteIcons.site_icon_tennis_ball
                          //,CssClasses.fadingAnim
                        ].join(" ")}
                      />
                    ) : (
                      <span>&nbsp;</span>
                    )}
                  </div>
                  <div className={CssClasses.currentServeGuest}>
                    {match.guestHasServe ? (
                      <span
                        className={[
                          SiteIcons.site_icon_tennis_ball
                          //,CssClasses.fadingAnim
                        ].join(" ")}
                      />
                    ) : (
                      <span>&nbsp;</span>
                    )}
                  </div>
                </div>
                <div className={CssClasses.currentGemBox}>
                  <div className={CssClasses.currentGemHome}>
                    {match.scoreGemHome}
                  </div>
                  <div className={CssClasses.currentGemGuest}>
                    {match.scoreGemGuest}
                  </div>
                </div>
              </Auxx>
            ) : null}

            {match.sportID === 20 ? ( //table tenis
              <Auxx>
                <div className={CssClasses.currentServeBox}>
                  <div className={CssClasses.currentServeHome}>
                    {match.homeHasServe ? (
                      <img
                        src={iconTableTennisBall}
                        alt=""
                        className={[
                          CssClasses.currentServeVolleyball,
                          //,CssClasses.fadingAnim
                          CssClasses.moreMargin
                        ].join(" ")}
                      />
                    ) : (
                      <span>&nbsp;</span>
                    )}
                  </div>
                  <div className={CssClasses.currentServeGuest}>
                    {match.guestHasServe ? (
                      <img
                        src={iconTableTennisBall}
                        alt=""
                        className={[
                          CssClasses.currentServeVolleyball,
                          //,CssClasses.fadingAnim
                          CssClasses.moreMargin
                        ].join(" ")}
                      />
                    ) : (
                      <span>&nbsp;</span>
                    )}
                  </div>
                </div>
              </Auxx>
            ) : null}

            {match.sportID === 23 ? ( //odbojka
              <Auxx>
                <div className={CssClasses.currentServeBox}>
                  <div className={CssClasses.currentServeHome}>
                    {match.homeHasServe ? (
                      <img
                        src={iconVolleyballBall}
                        alt=""
                        className={[
                          CssClasses.currentServeVolleyball,
                          //,CssClasses.fadingAnim
                          CssClasses.moreMargin
                        ].join(" ")}
                      />
                    ) : (
                      <span>&nbsp;</span>
                    )}
                  </div>
                  <div className={CssClasses.currentServeGuest}>
                    {match.guestHasServe ? (
                      <img
                        src={iconVolleyballBall}
                        alt=""
                        className={[
                          CssClasses.currentServeVolleyball
                          //,CssClasses.fadingAnim
                        ].join(" ")}
                      />
                    ) : (
                      <span>&nbsp;</span>
                    )}
                  </div>
                </div>
              </Auxx>
            ) : null}

            {match.setInfo.map(set => {
              let classNames = [];

              if (!set.isCurrentSet) {
                classNames.push(CssClasses.previousScoreBox);
              } else {
                classNames.push(CssClasses.currentScoreBox);
              }

              return (
                <div className={classNames.join(" ")} key={set.id}>
                  <div className={CssClasses.previousScoreHome}>
                    {set.homeScore}
                  </div>
                  <div className={CssClasses.previousScoreGuest}>
                    {set.guestScore}
                  </div>
                </div>
              );
            })} */}
            <div className={CssClasses.clearFix} />
          </div>
        </Auxx>
      );
    }
  };

  getButtons = (match, idOklada, margin) => {
    if (match === undefined || match.betInfo === undefined) {
      console.log("NO INFO ", match);
      return null;
    }

    //console.log("-----> MATCH IS ", match);

    //dohvati coefs
    let coefs = match.betInfo.filter(
      x =>
        x.betID === idOklada &&
        x.isActive &&
        (margin ? x.margin === margin : true)
    );

    //sortiraj
    //sortiraj
    coefs.sort((a, b) => {
      return a.order - b.order;
    });

    //console.log(coefs);

    let activeBets = this.props.ticketPairInfo.map(x => x.coefID);

    let markup = coefs.map(bet => {
      let isActive = activeBets.includes(bet.id);
      let classes = [
        CssClasses.fancyButton,
        isActive ? CssClasses.activeButton : ""
      ];
      //console.log("BET ", bet);

      let innerBtnClass = "";

      if (bet.isShown !== true) {
        classes.push(CssClasses.notShownOddButton);
        innerBtnClass = CssClasses.notShownOddButtonInner;
      } else if (bet.isEnabled !== true) {
        classes.push(CssClasses.disabledOddButton);
        innerBtnClass = CssClasses.disabledOddButtonInner;
      }

      let oddsAnim = "";

      if (bet.isShown) {
        if (bet.changeDirection > 0) {
          oddsAnim = CssClasses.increasedOdds;
        } else if (bet.changeDirection < 0) {
          oddsAnim = CssClasses.decreasedOdds;
        }
      }

      return (
        <div
          className={classes.join(" ")}
          key={bet.id}
          onClick={() => {
            this.btnChangeBetClick(match, bet.id);
          }}
        >
          <div className={CssClasses.legendPart}>{bet.shortName}</div>
          <div
            className={[
              CssClasses.oddsPart,
              isActive ? CssClasses.activeOdds : "",
              innerBtnClass,
              oddsAnim
            ].join(" ")}
          >
            {GetConvertedOdds(this.props.currentOddFormat, bet.value)}
          </div>
        </div>
      );
    });

    return markup;
  };

  btnChangeBetClick = (match, coefID) => {
    console.log("Btn change bet click for MID " + match.id + " CID " + coefID);

    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    //gasi
    this.props.changeLanguagePickerVisibility(false);
    this.props.changeSettingsPickerVisibility(false);

    if (match === undefined || coefID === 0 || match.betInfo === undefined) {
      //disabled
      return;
    }

    //console.log("MATCHES ", this.props.matches);

    //nadji match
    let bet = match.betInfo.find(x => x.id === coefID);
    let sport = {};

    if (this.props.isForPrematch) {
      sport = this.props.allSportsPrematch.find(
        x => x.sportID === match.sportID
      );
    } else {
      sport = this.props.allSportsLive.find(x => x.IDSport === match.sportID);
    }

    //console.log("MATCH ", match);
    //console.log("BET ", bet);

    if (!bet.isEnabled || !bet.isShown) {
      //disabled
      console.log("DISEJBLAN");
      return;
    }

    if (this.props.isForPrematch) {
      //dobij od servisa
      //probaj dohvatiti kuracpalac
      GetTicketPairs(
        ConvertLanguageCodeToJezikID(this.props.currentLanguage),
        coefID,
        this.getTicketPairs_Callback.bind(this),
        match,
        bet,
        sport
      );
      return;
    }

    let oldBetInfo = this.props.ticketPairInfo.find(x => x.coefID === coefID);

    if (oldBetInfo) {
      //vec je odabran, radi remove
      this.props.onRemovePair(match.id);
    } else {
      //radi add
      console.log("Adding pair..");
      this.props.onAddPair({
        coefID: bet.id,
        betID: bet.betID,
        matchID: match.id,
        matchName:
          match.homeTeam +
          " - " +
          match.guestTeam +
          " (" +
          match.scoreTotalHome +
          ":" +
          match.scoreTotalGuest +
          ")",
        betName: this.getBetName(bet, match),
        pick: this.getPickName(bet, match),
        odds: bet.value,
        checked: true,
        isLive: true,
        isShown: true,
        isEnabled: true,
        isFix: false,
        currentTime: match.currentTime,
        tournamentName: match.tournamentName,
        sportName: sport.Naziv,
        sportID: sport.IDSport
      });
    }
  };

  getTicketPairs_Callback = (data, match, bet, sport) => {
    console.log("IN CALLBACK FOR getTicketPairs_Callback WITH DATA ", data);

    if (!data) {
      console.log("NO DATA!");
      return;
    }

    if (data.length === 0) {
      console.log("EMPTY DATA!");
      return;
    }

    var betInfo = data[0];

    let oldBetInfo = this.props.ticketPairInfo.find(x => x.coefID === bet.id);

    if (oldBetInfo) {
      //vec je odabran, radi remove
      this.props.onRemovePair(match.id);
    } else {
      //radi add
      console.log("Adding pair..");
      this.props.onAddPair({
        coefID: bet.id,
        betID: bet.betID,
        matchID: match.id,
        matchName: betInfo.Domacin + " - " + betInfo.Gost,
        betName: betInfo.OkladaVrsta,
        pick: betInfo.TipPrevod,
        odds: betInfo.Kvota,
        checked: true,
        isLive: false,
        isShown: true,
        isEnabled: true,
        isFix: false,
        currentTime: 0,
        tournamentName: match.tournamentName,
        sportName: sport.title,
        matchStart: match.startTime,
        sportID: ConvertEmmettSportIDToBetRadarID(sport.sportID)
      });
    }
  };

  getPickName = (bet, match) => {
    //nadji tu okladu
    let betText = this.props.allBetsText.find(
      x => x.svoID === bet.sportVrstaOkladaID
    );

    let betInfo = this.props.allBets.find(x => x.IDOklada === bet.betID);

    if (betText === undefined || betInfo === undefined) {
      return "???";
    }

    let desc = bet.longName;
    desc = desc.replace("d!", match.homeTeam).replace("g!", match.guestTeam);

    return desc;
  };

  getBetName = (bet, match) => {
    //console.log("ALL BETS TEXT ", this.props.allBetsText);
    //console.log("ALL BETS ", this.props.allBets);

    //nadji tu okladu
    let betText = this.props.allBetsText.find(
      x => x.svoID === bet.sportVrstaOkladaID
    );

    let betInfo = this.props.allBets.find(x => x.IDOklada === bet.betID);

    if (betText === undefined || betInfo === undefined) {
      return "???";
    }

    // console.log("BET ", bet);
    console.log("BETTEXT ", betText);
    console.log("BETINFO ", betInfo);

    //podesi naziv brankovim algoritmom
    var OkladaNaziv = betInfo.Opis; //bitno isto iz raw oklade jer ne popuni za ostale ovo!
    var tmpOkladaTxt = betText;

    var tmpString = "";
    var indReplace = 1;

    if (!betInfo) {
      OkladaNaziv = "";
    }

    var tmpPosebnaV = betInfo ? betInfo.PosebnaVrijednost : "";
    if (tmpOkladaTxt.PosebnaVrijednostGrup.length > 0)
      tmpPosebnaV = tmpPosebnaV + "/" + tmpOkladaTxt.PosebnaVrijednostGrup;

    //pripremi naziv
    if (betInfo && OkladaNaziv.indexOf("$") > -1) {
      // if (tmpOkladaTxt.predznakNaslov === 1) {
      //   var posVrj = tmpPosebnaV;
      //   if (parseFloat(posVrj) > 0) {
      //     posVrj = "+" + posVrj;
      //   }
      //   OkladaNaziv = OkladaNaziv.replace("1$", posVrj);
      // } else

      if (tmpPosebnaV.indexOf("-") > 0 && tmpPosebnaV.indexOf("/-") === -1) {
        tmpString = tmpPosebnaV.replace("and", "-").split("-");
        indReplace = 1;

        for (let i = 0; i < tmpString.length; i++) {
          OkladaNaziv = OkladaNaziv.replace(
            indReplace.toString() + "$",
            tmpString[i]
          );
          indReplace++;
        }
      } else {
        tmpString = tmpPosebnaV.split("/");
        indReplace = 1;

        for (let i = 0; i < tmpString.length; i++) {
          OkladaNaziv = OkladaNaziv.replace(
            indReplace.toString() + "$",
            tmpString[i]
          );
          indReplace++;
        }
      }
    }

    // if (
    //   betInfo.PosebnaVrijednost &&
    //   betInfo.PosebnaVrijednost.indexOf(":") !== -1
    // ) {
    //   //ima rezultat, izbaci
    //   desc = desc.replace("[1$] ", "");
    // } else {
    //   //nema rezultat, ostavi kako je
    //   desc = desc.replace("1$", betInfo.PosebnaVrijednost);
    // }

    OkladaNaziv = OkladaNaziv.replace("d!", match.homeTeam).replace(
      "g!",
      match.guestTeam
    );

    return OkladaNaziv;
  };
}

const mapStateToProps = state => {
  return {
    currentLiveSportID: state.rrNavigation.liveSportID,
    currentPrematchSportID: state.rrNavigation.prematchSportID,
    liveExtraBetsID: state.rrNavigation.liveExtraBetsID,
    prematchExtraBetsID: state.rrNavigation.prematchExtraBetsID,
    currentActiveLiveTheme: state.rrAppState.currentActiveLiveTheme,
    updateStampOData: state.rrSportEvent.updateStampOData,
    ticketPairInfo: state.rrTicket.ticketPairInfo,
    currentOddFormat: state.rrAppState.oddFormatID,
    shouldQuickCloseExtraBets: state.rrNavigation.shouldQuickCloseExtraBets,
    allSportsLive: state.rrSportEvent.initialLiveSetInfo.Sportovi,
    allSportsPrematch: state.rrSportEvent.activePrematchSports,
    currentLanguage: state.rrAppState.currentLanguage
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSetLiveExtraBetsID: betsID =>
      dispatch(StoreActions.ChangeCurrentLiveExtraBetsID(betsID)),
    onSetPrematchExtraBetsID: betsID =>
      dispatch(StoreActions.ChangeCurrentPrematchExtraBetsID(betsID)),
    onAddPair: pairInfo => dispatch(StoreActions.AddPair(pairInfo)),
    onRemovePair: matchID => dispatch(StoreActions.RemovePair(matchID)),
    changeSettingsPickerVisibility: isShown =>
      dispatch(StoreActions.SetSettingsPickerVisibility(isShown)),
    changeLanguagePickerVisibility: isShown =>
      dispatch(StoreActions.SetLanguagePickerVisibility(isShown)),
    setCanShowExtraLiveBets: canShow =>
      dispatch(StoreActions.SetCanShowExtraLiveBets(canShow)),
    setCanShowExtraPrematchBets: canShow =>
      dispatch(StoreActions.SetCanShowExtraPrematchBets(canShow))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdditionalBets);



// WEBPACK FOOTER //
// ./src/Components/AdditionalBets/AdditionalBets.js